export default __webpack_public_path__ + "static/media/person.126e65e4.svg";